import {
  FullBenefitCode,
  TimeSheetBenefitCodesState,
} from '../../store/slices/timesheet/timesheetApprovalDetails/timesheetApprovalBenefitCodes';
import { FullBonusCode } from '../../store/slices/timesheet/timesheetBonusCodes';
import { BonusCode } from '../../store/slices/timesheet/timesheetPageSlice';

//copy of All Codes
export const handleInitialBenefitCodes = (data: FullBenefitCode[]) => {
  const copyOfFilteredBenefits: TimeSheetBenefitCodesState = {
    benefitCodes: {},
  };
  for (let i = 0; i < data?.length; i++) {
    const benefit = data[i];
    copyOfFilteredBenefits.benefitCodes[String(benefit.codeId)] = {
      codeId: benefit.codeId,
      description: benefit.description,
      isRepeated: benefit.isRepeated,
      isDisabled: benefit.isDisabled,
    };
  }
  return copyOfFilteredBenefits.benefitCodes;
};

//copy of the final object to deliver in approval or post
export const handleInitialBonusCodesPageDetail = (bonusCodes: BonusCode[]) => {
  const copyOfFilteredBonus: FullBonusCode[] = [];
  for (const bonusCode of bonusCodes) {
    const { codeId, code, description } = bonusCode;
    copyOfFilteredBonus.push({
      codeId,
      code,
      description,
      isRepeated: false,
      isDisabled: false,
    });
  }
  return [...copyOfFilteredBonus];
};

export const handleInitialBenefitsForApprovalSubmit = (
  benefitCodes: BonusCode[],
): number[] => benefitCodes.map((benefit) => parseInt(benefit.code));
